import { Box, Paper, Stack, type StackProps } from "@mui/material";
import { BodyTextM, HeadingM } from "@repo/ui";
import { type FC, type ReactElement } from "react";

interface ContactBoxProps extends StackProps {
	title?: string;
	description?: string;
	link?: ReactElement;
}

const ContactBox: FC<ContactBoxProps> = ({ title, description, link, ...rest }) => {
	return (
		<Box {...rest}>
			<HeadingM withoutScale>{title}</HeadingM>
			<Paper
				sx={{
					height: "100%",
					p: 4,
				}}
			>
				<Stack spacing={3} sx={{ alignItems: "start" }}>
					<BodyTextM>{description}</BodyTextM>
					{link}
				</Stack>
			</Paper>
		</Box>
	);
}

export default ContactBox;
